
  module.exports =
  {

    _init: function ()
    {

      this.onChangeReview()

    },

    onChangeReview: function ()
    {

      var review_type_id, date

      $('.js-review').not('.js-ignore').change(function ()
      {

        review_type_id = $(this).data('review_type_id')

        date = $(this).data('date')

        $.post(APPLICATION._PATH_PREFIX + 'reviews/add', {
          reviews: [{
            review_type_id: review_type_id,
            date: date,
            rating: $(this).val()
          }]
        }, function (response)
        {
          console.log(response)
        })

      }
      ).addClass('js-ignore')

    }
    
  }